<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.END_ACTION.DESCRIPTION' | translate }}
  </div>
  <div class="control-container">
    <glxy-input
      class="input"
      [label]="'AUTOMATIONS.EDITOR.TASKS.END_ACTION.REASON_LABEL' | translate"
      [formControl]="reasonFormControl"
    ></glxy-input>
  </div>
  <glxy-alert type="tip" size="small">
    <div>
      {{ 'AUTOMATIONS.COMMON.EARLY_ACCESS_DISCLAIMER' | translate }}
    </div>
  </glxy-alert>
</div>
